import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import type { AnchoredPlacement } from '../../anchored-overlay';
import { IconButtonComponent } from '../../button';
import { IconComponent } from '../../icon';
import {
  MenuComponent,
  MenuDeferredContentDirective,
  MenuItemRadioComponent,
  MenuSectionComponent,
  MenuTriggerDirective,
} from '../../menu';
import { SpinnerComponent } from '../../spinner';
import { StatusIconType, statusMapping } from '../status-mapping.helper';

interface StatusOption {
  status: StatusIconType;
  label: string;
}

// order of statuses in the menu
const statusOrder: StatusIconType[] = ['Approved', 'Pending', 'Declined'];

@Component({
  selector: 'sb-status-button',
  imports: [
    TranslatePipe,
    IconComponent,
    SpinnerComponent,
    IconButtonComponent,
    MenuComponent,
    MenuTriggerDirective,
    MenuDeferredContentDirective,
    MenuSectionComponent,
    MenuItemRadioComponent,
  ],
  templateUrl: './status-button.component.html',
})
export class StatusButtonComponent {
  placement = input<AnchoredPlacement>('bottom-end');

  status = input.required<StatusIconType>();

  saving = input(false);

  statusChange = output<StatusIconType>();

  statusMapping = statusMapping;

  options: StatusOption[] = statusOrder.map((status) => ({ status, label: statusMapping[status].label }));

  selectStatus(status: StatusIconType): void {
    if (status !== this.status()) {
      this.statusChange.emit(status);
    }
  }
}
